module.exports = __webpack_public_path__ + "img/partner-new-icon10.3ff9ffb0.svg";